import React, {useEffect, useState} from 'react'
import LogoPlaceholder from '../../../components/LogoPlaceHolder';

const Logo = (promoter) => {
    const {fullname,logoURL} = promoter.promoter
    return (
        <div className="home__logo">
            {logoURL && !logoURL.includes('null') ? <img src={logoURL} alt={fullname} /> :  <LogoPlaceholder name={fullname} />}
        </div>
    );
}

export default Logo;
